module.exports = __webpack_public_path__ + "img/Boleto.3a5e6111.jpg";